module.exports = __webpack_public_path__ + "img/96.1a882adb.jpg";